export function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://cdn.gorilladash.com/static/clients/signarama/images/logos/signarama40th-new-logo.png?fit=contain&format=jpeg&auto=avif%2Cwebp" 
              alt="Signarama Logo" 
              className="h-10 w-auto mb-6"
            />
            <p className="text-gray-400 text-sm mb-6">
              Your trusted partner for custom signage solutions in Arlington, TX. Quality signs that get you noticed.
            </p>
            <div className="flex items-center space-x-3">
              <a href="https://www.facebook.com/SignaramaArlingtonTX/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://www.linkedin.com/in/adil-elghardgui-443aaa13a/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="https://g.co/kgs/1jxvQT5" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-500 transition-colors cursor-pointer">
                <i className="ri-google-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">Our Services</a></li>
              <li><a href="#portfolio" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">Portfolio</a></li>
              <li><a href="#process" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">How It Works</a></li>
              <li><a href="#testimonials" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">Testimonials</a></li>
              <li><a href="#quote-form" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">Get A Quote</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6">Services</h4>
            <ul className="space-y-3">
              <li><span className="text-gray-400 text-sm">Vehicle Wraps</span></li>
              <li><span className="text-gray-400 text-sm">Storefront Signs</span></li>
              <li><span className="text-gray-400 text-sm">Banners & Displays</span></li>
              <li><span className="text-gray-400 text-sm">Trade Show Graphics</span></li>
              <li><span className="text-gray-400 text-sm">Promotional Materials</span></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-teal-400 text-xl mt-1"></i>
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=32.708617,-97.147128&query_place_id=ChIJkRKWLsV8ToYRhAcULCMpvSc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 text-sm hover:text-teal-400 transition-colors cursor-pointer"
                >
                  2400 W Pioneer Pkwy #118<br />
                  Arlington, Texas 76013
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-teal-400 text-xl"></i>
                <a href="tel:817-860-9310" className="text-gray-400 text-sm hover:text-teal-400 transition-colors cursor-pointer">817-860-9310</a>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-time-line text-teal-400 text-xl mt-1"></i>
                <div className="text-gray-400 text-sm">
                  Monday - Friday<br />
                  8:00 AM - 6:00 PM
                </div>
              </div>

              {/* Embedded Map */}
              <div className="rounded-xl overflow-hidden mt-4 border border-white/10">
                <iframe
                  title="Signarama Arlington Map"
                  src="https://maps.google.com/maps?q=2400+W+Pioneer+Pkwy+%23118+Arlington+TX+76013&output=embed&z=15"
                  width="100%"
                  height="180"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2026 Signarama Arlington, TX. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="https://signarama.com/about/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-teal-400 transition-colors cursor-pointer">Privacy Policy</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-teal-400 transition-colors cursor-pointer">Website Builder</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}